export class QueryConfig {
    field: string;
    path: string;
    queryField: string;
    queryValue: any;
    limit: number;
    reverse: boolean;
    prepend: boolean;
    opts: any
}


// WEBPACK FOOTER //
// ./src/app/models/queryConfig.model.ts